module.exports = __webpack_public_path__ + "static/media/logo.e17e3636.png";